// extracted by mini-css-extract-plugin
export default {"dragZone":"dragZone__l2d4r","dragZone__box":"dragZone__box__NU_pA"};